import React, { FC } from "react";
import { Column, Row } from "../../Fundamentals/Grid";
import BrandTile, { TBrand } from "./BrandTile";

import { ILinkProps } from "../../ActionsSelectors/Link/Link";

export interface IBrandItemType<LinkType> extends ILinkProps<LinkType> {
  brandType?: TBrand;
  id?: number;
}

export interface IBrandsProps<LinkType> {
  items: IBrandItemType<LinkType>[];
}

const Brands: FC<IBrandsProps<LinkStyle>> = ({ items }) => (
  <Row>
    {items?.map((item) => (
      <Column key={item?.id} xs={6} classes={{ root: "mb-6" }}>
        <BrandTile type={item?.brandType} linkParams={item.linkParams} />
      </Column>
    ))}
  </Row>
);

export default Brands;
